/**
 * REVIVO cart feedback
 * Keeps every header cart badge in sync right after an AJAX add-to-cart,
 * and gives it a quick "pop" so the click always feels confirmed —
 * on top of (not instead of) the "Added to cart" popup.
 */
document.addEventListener('DOMContentLoaded', function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function bump(el) {
    el.classList.remove('revivo-badge-pop');
    void el.offsetWidth; // restart animation on rapid repeat clicks
    el.classList.add('revivo-badge-pop');
  }

  function updateBadges(count) {
    document.querySelectorAll('[data-cart-count-badge]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-cart-empty', count === 0);
      bump(el);
    });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBadges(cart.item_count); })
      .catch(function (err) { console.warn('Revivo cart feedback: could not refresh badge', err); });
  });
});
